import { MAP_ELEMENT_TYPES } from '../../../../constants/graph';
import MapElementModal from '../../../graph/MapElementModal';
import { CRUD_OPERATION_TYPES } from '../common/constants';
import screens from '../common/screens';
import { DataActionProvider } from '../contextProviders/DataActionProvider';
import { ListenerProvider } from '../contextProviders/ListenerProvider';
import {
    type MapElementConfigProps,
    MapElementProvider,
} from '../contextProviders/MapElementProvider';
import LoadRouter from './LoadRouter';

const Load = (props: MapElementConfigProps) => {
    return (
        <MapElementProvider
            {...props}
            defaultScreen={screens.load}
            elementType={MAP_ELEMENT_TYPES.databaseLoad}
            isLoading={false}
        >
            <MapElementModal>
                <DataActionProvider
                    defaultScreen={screens.load}
                    crudOperationType={CRUD_OPERATION_TYPES['load']}
                >
                    <ListenerProvider defaultScreen={screens.load}>
                        <LoadRouter />
                    </ListenerProvider>
                </DataActionProvider>
            </MapElementModal>
        </MapElementProvider>
    );
};

export default Load;
